import createGlobe from "cobe";
import { useEffect, useRef, useState, memo } from "react";

export const Globe = memo(({ className, config }) => {
  const canvasRef = useRef(null);
  const containerRef = useRef(null);
  const [opacity, setOpacity] = useState(0);
  const [size, setSize] = useState(600);

  // Detect container size
  useEffect(() => {
    const updateSize = () => {
      if (containerRef.current) {
        const containerWidth = containerRef.current.offsetWidth;
        // Use container width, but cap at 600 for large screens
        setSize(Math.min(containerWidth, 600));
      }
    };

    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, []);

  useEffect(() => {
    let phi = 0;

    if (!canvasRef.current || size === 0) return;

    const globe = createGlobe(canvasRef.current, {
      devicePixelRatio: 1,
      width: size,
      height: size,
      phi: 0,
      theta: 0,
      dark: 1,
      diffuse: 1.2,
      mapSamples: 12000,
      mapBrightness: 6,
      baseColor: [0.3, 0.3, 0.3],
      markerColor: [1, 0.4, 0], 
      glowColor: [0.1, 0.1, 0.1],
      markers: [
        { location: [37.7595, -122.4367], size: 0.03 }, // San Francisco (Google)
        { location: [51.1694, 71.4491], size: 0.1 },    // Astana (Astana Hub)
      ],
      onRender: (state) => {
        state.phi = phi;
        phi += 0.01;
      },
      ...config,
    });

    setTimeout(() => setOpacity(1), 100);

    return () => {
      globe.destroy();
    };
  }, [config, size]);

  return (
    <div
      ref={containerRef}
      className={className}
      style={{
        width: "100%",
        maxWidth: 600,
        aspectRatio: 1,
        margin: "auto",
        position: "relative",
      }}
    >
      <canvas
        ref={canvasRef}
        style={{
          width: "100%",
          height: "100%",
          opacity: opacity,
          transition: "opacity 1s ease",
        }}
      />
    </div>
  );
});
